import {
  monthlyReportRoutes,
  MonthlyReportSteps,
  MonthlyReportStepsTitle,
} from "../../../interfaces/interfaces";

export const monthlyReportStepperList = [
  {
    name: MonthlyReportSteps.connectAccounts,
    title: MonthlyReportStepsTitle.connectAccounts,
    link: monthlyReportRoutes.connectAccounts,
  },
  {
    name: MonthlyReportSteps.bankStatement,
    title: MonthlyReportStepsTitle.bankStatement,
    link: monthlyReportRoutes.bankStatement,
  },
  {
    name: MonthlyReportSteps.salesMarketing,
    title: MonthlyReportStepsTitle.salesMarketing,
    link: monthlyReportRoutes.salesMarketing,
  },
  {
    name: MonthlyReportSteps.businessUpdates,
    title: MonthlyReportStepsTitle.businessUpdates,
    link: monthlyReportRoutes.businessUpdates,
  },
  {
    name: MonthlyReportSteps.gst,
    title: MonthlyReportStepsTitle.gst,
    link: monthlyReportRoutes.gst,
  },
  {
    name: MonthlyReportSteps.recipients,
    title: MonthlyReportStepsTitle.recipients,
    link: monthlyReportRoutes.recipients,
  },
];
